import { Theme } from '@/theme';
import styled from 'styled-components';

const BUTTON_SIZE = 'clamp(40px, 8vmin, 40px)';

export default styled.button`
  background-color: ${Theme.color.orange};

  right: 17px;
  bottom: 18px;

  height: ${BUTTON_SIZE};
  width: ${BUTTON_SIZE};

  border-radius: 50%;
  position: absolute;
  display: block;

  padding: 5px;
  z-index: 2;

  svg {
    height: 18px;
    width: 18px;
  }
`;
